function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function pollSegmentTaskMock(taskId, projectId, durationSeconds, options = {}) {
  const stages = [
    { status: 'PENDING', progressPercent: 0, progressMessage: '排队中' },
    { status: 'RUNNING', progressPercent: 30, progressMessage: '正在切片…' },
    { status: 'RUNNING', progressPercent: 70, progressMessage: '正在生成缩略图…' },
    { status: 'SUCCESS', progressPercent: 100, progressMessage: '切片完成' },
  ];

  for (const stage of stages) {
    if (options.onProgress) {
      options.onProgress(stage);
    }
    await delay(400);
  }

  const count = Math.max(1, Math.ceil(600 / durationSeconds));
  const segments = [];
  for (let i = 1; i <= count; i += 1) {
    const start = (i - 1) * durationSeconds;
    const end = Math.min(start + durationSeconds, 600);
    segments.push({
      id: `seg-mock-${i}`,
      index: i,
      startMs: start * 1000,
      endMs: end * 1000,
      fileName: `demo_${String(i).padStart(3, '0')}.mp4`,
      url: '',
      thumbnailUrl: '',
      durationSeconds: end - start,
      sizeBytes: 1024 * 1024 * 5,
    });
  }

  return {
    taskId,
    projectId,
    status: 'SUCCESS',
    segments,
  };
}
